import {type Icon, IssueClosedIcon, IssueDraftIcon, IssueOpenedIcon, SkipIcon} from '@primer/octicons-react'

import {IssueInProgressIcon} from './IssueInProgressIcon'
import styles from './IssueStatusIcon.module.css'

export type IssueStatusIconStatus = {
  name: string
  category: {state: 'OPEN' | 'CLOSED'}
}

export type IssueStatusColor = 'open' | 'done' | 'muted'

export type IssueStatusVisual = {icon: Icon; color: IssueStatusColor}

// Keyed by name while statuses are in flux.
const STATUS_VISUALS: Record<string, IssueStatusVisual> = {
  New: {icon: IssueOpenedIcon, color: 'open'},
  Backlog: {icon: IssueDraftIcon, color: 'muted'},
  Todo: {icon: IssueOpenedIcon, color: 'open'},
  'In Progress': {icon: IssueInProgressIcon, color: 'open'},
  Done: {icon: IssueClosedIcon, color: 'done'},
  'Not planned': {icon: SkipIcon, color: 'muted'},
  Duplicate: {icon: SkipIcon, color: 'muted'},
}

const ICON_CLASSES: Record<IssueStatusColor, string> = {
  open: styles.open,
  done: styles.done,
  muted: styles.muted,
}

export function issueStatusVisual(status: IssueStatusIconStatus): IssueStatusVisual {
  return (
    STATUS_VISUALS[status.name] ??
    (status.category.state === 'OPEN' ? {icon: IssueOpenedIcon, color: 'open'} : {icon: IssueClosedIcon, color: 'done'})
  )
}

export function IssueStatusIcon({status}: {status: IssueStatusIconStatus}) {
  const {icon: StatusIcon, color} = issueStatusVisual(status)
  return <StatusIcon className={ICON_CLASSES[color]} />
}
